import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonos } from '../data/content';
export function BonosSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="bonos-title" data-id="element-15" data-mp="13cw2msp6osen">
      <div className="mx-auto max-w-6xl" data-id="element-16" data-mp="yebazhnzzh1t">
        <SectionHeading eyebrow="🎁 Siempre incluidos" title="6 Bonos estratégicos" data-id="element-17" data-mp="tfq7989jef8m" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="og5a93dxggyj">
          {bonos.map((bono, index) => <motion.li key={bono.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-col rounded-2xl border border-line bg-ink p-6" data-id="element-19" data-mp="kg37eqwghhho" data-mpi={index}>
              <div className="flex items-center gap-2" data-id="element-20" data-mp="qvef7oqt1u66">
                <span className="text-sm font-extrabold text-neutral-600" data-id="element-21" data-mp="qtuxdtpi3b2a">
                  {bono.id}
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/12 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.15em] text-gold" data-id="element-22" data-mp="vs4s637bc9nd">
                  <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-23" data-mp="muclfnfnqabl" />
                  Bono
                </span>
              </div>
              <h3 className="mt-3 text-xl font-extrabold leading-tight tracking-tight text-white" data-id="element-24" data-mp="1alrk968869i3">
                {bono.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-neutral-400" data-id="element-25" data-mp="10sj3bu47nzpm">
                {bono.description}
              </p>
              <p className="mt-4 flex items-center gap-2 border-t border-line pt-4 text-sm" data-id="element-26" data-mp="15qkjo7a95kxe">
                <span className="text-neutral-600 line-through" data-id="element-27" data-mp="1tgyaxvl0jfqx">
                  {bono.value}
                </span>
                <span className="font-extrabold uppercase tracking-wide text-gold" data-id="element-28" data-mp="1yasriq5bnels">
                  Gratis
                </span>
              </p>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl rounded-3xl border border-gold/30 bg-gold/[0.06] px-6 py-6 text-center text-lg font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-29" data-mp="23410pxynaut9">
          Valor total bonos{' '}
          <span className="line-through opacity-50" data-id="element-30" data-mp="1p5u8axcgtn0z">$53.000</span> →{' '}
          <span className="text-gold" data-id="element-31" data-mp="1p870s4funfsa">GRATIS con tu Megakit</span>
        </p>
      </div>
    </section>;
}